import React, { useContext, useMemo, useState } from 'react';
import { ComparisonBuilder, DateUtils, sum } from 'simple-utils';
import { Image } from '../components/Image';
import { useIsGuest } from '../login/AuthContext';
import { getAdsLink } from '../models/Account';
import { bigNumber, formatMoney } from '../utils/money-utils';
import { AdDetailContext } from './DetailStore';
import { DetailReportData } from './models';

export interface AdSummary {
    ad?:string
    leads: number
    cpl: number
    cost: number
    thumb: string
    status?: "ACTIVE" | "PAUSED"
    reach?: number
}

const ads:AdSummary[] = [
    {
       "ad": "FGHARMHD211003",
       "cost": 1073.6,
       "leads": 87,
       "thumb": "https://scontent.fudi1-1.fna.fbcdn.net/v/t15.5256-10/296228552_1190148821774183_6083446563745367818_n.jpg?_nc_cat=103&ccb=1-7&_nc_eui2=AeGxGZxlcZMbzuDs02RvPE_mII9PQVSHUz4gj09BVIdTPvV6uKUYTtr8VNdLchbHl2YzY80VBXCPM7_Zyh41q6oO&_nc_ohc=W8OGwN6wz8EQ7kNvgFx10uI&_nc_ht=scontent.fudi1-1.fna&edm=AAT1rw8EAAAA&stp=c0.5000x0.5000f_dst-emg0_p120x120_q75&ur=7965db&_nc_sid=58080a&oh=00_AYCrhinbKyPyPsP-mXLmGsaWfVt56yjEuKUUNZSemAh7Sg&oe=66CFFDEB",
       "cpl": 12.34022988505747
    }
 ]

function BoxFb(){
    return <div style={{width:"64px", height:"64px", background:"#0002", borderRadius:"3px", marginRight:"10px"}}></div>
}

function AdSummaryItem({ad, showLabel}:{ad:AdSummary, showLabel:boolean}){
    const guest = useIsGuest();
    function checkImg(i:HTMLImageElement){
        return i.naturalWidth > 1;
    }

    const paused =  ad.status && ad.status != 'ACTIVE'

    return <div className="ad-summary-item position-relative col-md-4 col-lg-3">
        <Image src={ad.thumb} fallback={<BoxFb />} checkImg={checkImg} className={`${paused ? 'opacity-50' : ''}`} />
        <div className='ad-summary-info' style={{width:"calc(100% - 68px)"}}>
            {showLabel && <b className='d-block text-truncate small'>{ad.ad}</b>}
            Leads: <b>{ad.leads}</b><br />
            <div className='d-flex justify-content-between'>
                {ad.reach && <small>Alcance: <b>{bigNumber(ad.reach)}</b></small>}
                {showLabel && <small>CPL: <b>{formatMoney(ad.cpl)}</b></small>}
            </div>
            {showLabel && <small>Investimento: <b>{formatMoney(ad.cost)}</b></small>}
            {paused && <i className='fa fa-pause' style={{position:'absolute', top: "20px", left: "34px", color:"white", fontSize: "30px"}}></i>}
        </div>
    </div>
}

export function AdSummaryItemList() {
   const {state} = useContext(AdDetailContext);
   if(!state.report.detail?.ads)
      return null;

   const guest = useIsGuest();
   const [showLabel, setShowLabel] = useState(false);
   const ads = useMemo(function(){
      var a = state.report.detail?.ads
      a.sort((a, b) => new ComparisonBuilder()
            .add(a.leads, b.leads, 'desc')
            .add(a.cpl, b.cpl)
            .add(a.cost, b.cost)
            .result())
      if(guest)
        return a.slice(0, 30)
      return a;
   }, [])

   return <>
        <h3 className='my-3 d-flex justify-content-between'>Anúncios <a className="btn btn-secondary btn-sm ms-2" target="_blank" href={getAdsLink(state.report.report)}><i className="fas fa-bullhorn me-1"></i> Biblioteca de anúncios</a></h3>
        <div className='row' onClick={() => {setShowLabel(!showLabel)}}>
        {ads.map((a, i) => <AdSummaryItem ad={a} key={i} showLabel={showLabel} />)}
    </div>
        {!guest && <UpdateStats data={state.report.detail} /> }
    </>
}

function UpdateStats({data}:{data:DetailReportData}){
    const info = useMemo(()=>{
        if(!data) return null;
        const updatedAt = data.updatedAt ? new Date(data.updatedAt * 1000) : null
        const totalLeads = sum(data.ads, a => a.leads);
        return {updatedAt, totalLeads}

    }, [data])
    if(!info) return;
    return <div className='mt-3'>
        {info.updatedAt != null && <><b>Relatório de anúncios atualizado em:</b> {DateUtils.formatDatetime(info.updatedAt)}<br /></>}
        <b>Total leads:</b> {info.totalLeads} nos Top {data.ads.length} anúncios apresentados na lista acima.
    </div>
}